module.exports = __webpack_public_path__ + "img/bp4202_center_002.79b86722.png";